import { render } from "./authenDesigner.vue?vue&type=template&id=48404288&scoped=true"
import script from "./authenDesigner.vue?vue&type=script&lang=js"
export * from "./authenDesigner.vue?vue&type=script&lang=js"

import "./authenDesigner.vue?vue&type=style&index=0&id=48404288&lang=scss&scoped=true"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48404288"]])

export default __exports__